import { mapIWSettingsDTOToIWSettings } from "../../../../api/mappers/IWSettingsMapper";
import apiService from "../../../../api/rest";
import { isNumeric, MAPI_API_TYPE, OAPI_API_TYPE, tokenIsValidForVenue, SENTRY_ERRORS } from "../../../utils";
import errorLoggerAdapter from "@/adapters/errorLoggerAdapter";

export const getDefaultState = () => {
  return {
    settings: null
  };
};

// initial state
const state = getDefaultState();

const getters = {
  getVenueSettings(state) {
    return state.settings || {};
  },
  showMenuItemsImages(state, getters) {
    return getters.getVenueSettings.showImages === 1;
  },
  isActiveVenue(state, getters) {
    return function (customString) {
      return customString === getters.getVenueSettings.venueId || customString === getters.getVenueSettings.url;
    };
  },
  topLevelCategoriesAreSuppressed(state, getters) {
    return getters.getVenueSettings.suppressTopLevelCategories === 1;
  },
  applePayEnabled(state, getters) {
    return getters.getVenueSettings.applePayEnabled || 0;
  },
  seatRequired(state, getters) {
    return getters.getVenueSettings.seatRequired || 0;
  },
  getLayout(state, getters) {
    return getters.getVenueSettings.layout;
  },
  getAllowLogin(state, getters) {
    return !!getters.getVenueSettings.allowLogin;
  },
  isLoginAllowed(state, getters) {
    return getters.getVenueSettings.allowLogin === 1;
  },
  getRewardsAutoLookup(state, getters) {
    return getters.getVenueSettings.rewardsAutoLookup || 0;
  },
  getRewardsGuidanceText(state, getters) {
    return getters.getVenueSettings.rewardsGuidanceText || "";
  },
  getRewardProviders(state, getters) {
    return getters.getVenueSettings.rewardProviders || [];
  },
  APIType(state) {
    if (Number(state.settings?.useOrderingApi) === 1) return OAPI_API_TYPE;
    return MAPI_API_TYPE;
  }
};

const actions = {
  async fetchInteractWebSettings({ getters, rootGetters, commit, dispatch }, customString) {
    const iwToken = rootGetters["common/getIwToken"];
    if (getters.isActiveVenue(customString) && iwToken) {
      errorLoggerAdapter.initReplays();
      return Promise.resolve(getters.getVenueSettings);
    }

    return await actions.updateInteractWebSettings({ rootGetters, commit, dispatch }, customString);
  },

  async updateInteractWebSettings({ rootGetters, commit, dispatch }, customString) {
    const path = isNumeric(customString) ? `id/${customString}` : `url/${customString}`;

    try {
      const connectResponse = await apiService.fetchInteractWebSettings(path);
      dispatch("common/updateIWSettingsTimeStamp", null, {
        root: true
      });
      if (connectResponse.data) {
        const settings = mapIWSettingsDTOToIWSettings(connectResponse.data);

        commit("applySettings", settings);

        const iwToken = rootGetters["common/getIwToken"];
        //Call init function when an iwToken is not in app state or token is not valid for the venue
        if (!iwToken || !tokenIsValidForVenue(iwToken, connectResponse.data.venueId)) {
          await dispatch("common/authenticate", settings.venueId, {
            root: true
          });
        }

        try {
          //Fetch featureFlags once the venue is valid and don't stop IW if flags can't be fetch
          await dispatch("featureFlags/fetchFeatureFlags", "", { root: true });
        } catch (error) {
          commit("featureFlags/resetState", "", { root: true });
          errorLoggerAdapter.createIssue(
            SENTRY_ERRORS.ERROR_FETCH_FEATURE_FLAGS,
            "fetchFeatureFlagsError",
            "updateInteractWebSettings",
            { description: error.toString() || "" },
            error
          );
        }
        return settings;
      }

      // If we reach this point, we didn't receive the correct data from connect
      console.error("initialize data error from connect");
      return {};
    } catch (e) {
      console.error("error initializing IW settings");
      return {};
    }
  }
};

const mutations = {
  applySettings(state, settings) {
    state.settings = settings;
  },
  changeThemePreference(state, theme) {
    state.settings.theme = theme;
  },
  resetState(state) {
    Object.assign(state, getDefaultState());
  }
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
};
